// src/components/AppointmentScheduler.jsx

import React from 'react';
import { Fade } from 'react-awesome-reveal';

const AppointmentScheduler = () => {
  return (
    <section className="appointment-scheduler section-parallax-5 section">
        		<Fade direction="up" cascade={true} damping={.5} delay={400} triggerOnce>
		<div className="container">

      <h2>Schedule a Meeting with Murtaza Lightwala</h2>
      <p>
  Ready to discuss your next big idea? Select a convenient time from my calendar below to book a meeting.
</p>
      {/* Google Calendar Appointment Scheduling begin */}
      <iframe
        src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ3ftI5c-7safYh7WKHERrFgZeosBRVJZk1ctSkxmK1xIxDIojmOVKAsf7X9rDpSGxFziYApfyaN?gv=true"
        style={{ border: '0', background: '#ebe7e0', padding: '1em', borderRadius: '1em' }}
        width="100%"
        height="600px"
        frameBorder="0"
        scrolling="yes"
        title="Schedule a Meeting with Murtaza Lightwala"
      ></iframe>
      {/* end Google Calendar Appointment Scheduling */}
      </div>
      </Fade>
    </section>
  );
};

export default AppointmentScheduler;
